export default {
  SECURE_SSN_INIT: 'SECURE_SSN_INIT',
  SECURE_DRIVER_LICENSE_INIT: 'SECURE_DRIVER_LICENSE_INIT',
  CHANGE_LANGUAGE: 'CHANGE_LANGUAGE',
  SUBMIT: 'submit',
  FOCUS_ON_IT: 'FOCUS_ON_IT',
};
